<template>
  <section>
    <div class="z-card border-0 integration-page">
      <h4>{{ $t('integration.api.phones_unoccupied') }}</h4>
      <ul class="list-unstyled integration-list-info">
        <li><b>URL:</b> https://my.zorra.com/api/v1/phones/unoccupied</li>
        <li><b>Content-Type:</b> application/json</li>
        <li><b>Method:</b> POST</li>
        <li><b>Headers:</b> Authorization: Bearer %TOKEN%</li>
      </ul>
      <p>{{ $t('integration.api.answer_example') }}</p>
      <pre>
<code class="json hljs">
  {
      <span class="hljs-attr">"success"</span>: <span class="hljs-literal">true</span>,
      <span class="hljs-attr">"total"</span>: <span class="hljs-number">1</span>,
      <span class="hljs-attr">"data"</span>: [
          {
              <span class="hljs-attr">"id"</span>: <span class="hljs-number">1</span>,
              <span class="hljs-attr">"number"</span>: <span class="hljs-string">"79990009900"</span>,
              <span class="hljs-attr">"connection_cost"</span>: <span class="hljs-string">"3.00000"</span>,
              <span class="hljs-attr">"subscription_fee"</span>: <span class="hljs-string">"3.00000"</span>,
              <span class="hljs-attr">"minutes_cost"</span>: <span class="hljs-string">"3.00000"</span>,
              <span class="hljs-attr">"owner_id"</span>: <span class="hljs-number">1</span>,
              <span class="hljs-attr">"country_id"</span>: <span class="hljs-number">1</span>,
              <span class="hljs-attr">"check_status"</span>: <span class="hljs-string">"missing"</span>,
              <span class="hljs-attr">"status"</span>: <span class="hljs-string">"stand_by"</span>,
              <span class="hljs-attr">"type"</span>: <span class="hljs-string">"local"</span>,
              <span class="hljs-attr">"created_at"</span>: <span class="hljs-string">"2019-01-01 01:02:03"</span>,
              <span class="hljs-attr">"activated_at"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"canceled_at"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"purchased_at"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"checked_at"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"deleted_at"</span>: <span class="hljs-literal">null</span>,
              <span class="hljs-attr">"deactivated_at"</span>: <span class="hljs-literal">null</span>
          }
      ]
  }
</code>
      </pre>
    </div>
  </section>
</template>

<script>
  export default {};
</script>
<style lang="scss">
  @import '~@/assets/styles/scss/highlight/monokai';
  @import '~@/assets/styles/scss/pages/integration';
</style>
